import { useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { useTenant } from '../../../providers/tenant';

/**
 * Tenant Name component to set the tenant name
 */
export default function TenantName() {
    const { tenantId } = useParams<any>();
    const { setTenantName } = useTenant();

    useEffect(() => {
        setTenantName(tenantId);
    }, [tenantId]);

    return null;
}
